import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type LoadingVariant = 'pdf' | 'excel';

@Injectable({ providedIn: 'root' })
export class PdfLoadingService {
    private _visible = new BehaviorSubject<boolean>(false);
    private _label   = new BehaviorSubject<string>('');
    private _variant = new BehaviorSubject<LoadingVariant>('pdf');

    visible$  = this._visible.asObservable();
    label$    = this._label.asObservable();
    variant$  = this._variant.asObservable();

    show(label = 'Generando PDF...', variant: LoadingVariant = 'pdf') {
        this._variant.next(variant);
        this._label.next(label);
        this._visible.next(true);
    }

    hide() {
        this._visible.next(false);
        this._label.next('');
        this._variant.next('pdf');
    }
}
